import $ from 'jquery';
import TomSelect from 'tom-select';

require('tom-select/dist/js/plugins/remove_button')
require('tom-select/dist/js/plugins/dropdown_input')

let isRecaptchaSuccess = false;
let demoOrderContainer = null;
let submitButtonElement = null;

const demoOrderRecaptchaCallback = function (response) {
    isRecaptchaSuccess = !!response;
    submitButtonElement[validateRequiredField(demoOrderContainer) ? 'removeAttr' : 'attr']('disabled', true);

    if (isRecaptchaSuccess) {
        resetError(demoOrderContainer, '#error-g-recaptcha-response');
    }
}

const validateRequiredField = function ($popup, target = null) {
    let state = true;
    const $inputs = $popup.find('input, textarea, select').filter(':not([disabled])').filter('[required]');

    if (target) {
        resetError($popup, '#error-' + target.name.replace('[]', ''));
    }

    if ($inputs.length) {
        $inputs.each((idx, input) => {
            if (input.type === 'checkbox') {
                if (!input.checked) {
                    state = false;
                    return false;
                }
            } else {
                if (!input.value.trim()) {
                    state = false;
                    return false;
                }
            }
        })
    }

    return state && isRecaptchaSuccess;
}

const resetError = function ($popup, selector) {
    if ($popup.find(selector).is(':visible')) {
        $popup.find(selector).text('').hide();
    }
}

const resetErrors = function ($popup) {
    const $inputs = $popup.find('input, textarea, select').filter(':not([disabled])').filter('[required]');

    if ($inputs.length) {
        $inputs.each((idx, input) => {
            resetError($popup, '#error-' + input.name.replace('[]', ''));
        })
    }

    resetError($popup, '#error-unknown');
}

const showErrors = function ($popup, errors) {
    let found = false;

    $.each(errors, (name, messages) => {
        let element = $popup.find('#error-' + name.replace('[]', ''));
        if (element) {
            element.text(messages[0]).show();
            found = true;
        }
    })

    if (!found) {
        $popup.find('#error-unknown').text('Неизвестная ошибка').show();
    }
}

const popupDemoOrderHandler = function ($demoOrderContainer) {

    const tomSelect = new TomSelect('#demo_order_vendors', {
        plugins: {
            remove_button: {
                title: 'Убрать',
            },
            dropdown_input: {}
        },
        render: {
            no_results: function (data, escape) {
                return '<div class="no-results">Не найдено</div>';
            },
        }
    });

    demoOrderContainer = $demoOrderContainer;
    const $submitButton = $demoOrderContainer.find('button[type="submit"]');
    submitButtonElement = $submitButton;

    $('body').on('popup.after_close', function () {
        const recaptchaId = $demoOrderContainer.find('.g-recaptcha').data('recaptcha-id');
        if (recaptchaId !== undefined) {
            grecaptcha.reset(recaptchaId);
        }
        tomSelect.clear();
    });

    $demoOrderContainer.on('change input', 'input, textarea, select', function (e) {
        $submitButton[validateRequiredField($demoOrderContainer, e.target) ? 'removeAttr' : 'attr']('disabled', true);
    });

    $demoOrderContainer.on('reset', function () {
        $submitButton[validateRequiredField($demoOrderContainer) ? 'removeAttr' : 'attr']('disabled', true);
        const recaptchaId = $demoOrderContainer.find('.g-recaptcha').data('recaptcha-id');
        if (recaptchaId !== undefined) {
            grecaptcha.reset(recaptchaId);
        }
    })

    let isBusy = false;
    $demoOrderContainer.find('form').on('submit', function (e) {
        const form = this;

        e.preventDefault();

        if (isBusy) {
            return;
        }

        resetErrors($demoOrderContainer);
        isBusy = true;

        form.classList.add('_is-busy');

        $.ajax({
            url: form.action,
            type: form.method || 'post',
            data: $(form).serialize(),
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                if (Object.hasOwn(response, 'success')) {
                    $.popup.info(['Заявка успешно отправлена.'], {center: true});

                    setTimeout(() => {
                        isBusy = false;
                        form.classList.remove('_is-busy');
                        form.reset();
                    }, 600);
                }
            },
            error: function (response) {
                isBusy = false;
                form.classList.remove('_is-busy');
                const recaptchaId = $demoOrderContainer.find('.g-recaptcha').data('recaptcha-id');
                if (recaptchaId !== undefined) {
                    grecaptcha.reset(recaptchaId);
                }
                isRecaptchaSuccess = false;
                $submitButton[validateRequiredField($demoOrderContainer) ? 'removeAttr' : 'attr']('disabled', true);

                var data = JSON.parse(response.responseText);
                showErrors($demoOrderContainer, Object.hasOwn(data, 'errors') ? data.errors : []);
            }
        })
    });
};

export {
    popupDemoOrderHandler,
    demoOrderRecaptchaCallback
};
